import { render, staticRenderFns } from "./PremiumStickyCta.vue?vue&type=template&id=e4a9ce70&scoped=true"
import script from "./PremiumStickyCta.vue?vue&type=script&lang=ts"
export * from "./PremiumStickyCta.vue?vue&type=script&lang=ts"
import style0 from "./PremiumStickyCta.vue?vue&type=style&index=0&id=e4a9ce70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a9ce70",
  null
  
)

export default component.exports